module.exports = __webpack_public_path__ + "media/images/prismic_catalog/presentation_cards/universes/massage-f9eadf085d3e0b927da0cea961ab01b6.png";